import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ReadingIntro({ mockId, passageId = 1 }) {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`/data/${mockId}Reading${passageId}.json`)
      .then((res) => res.json())
      .then(setData)
      .catch((err) => console.error("Failed to load mock data:", err));
  }, [mockId, passageId]);

  if (!data) return <div className="p-4">Loading...</div>;

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Reading Section - Passage {passageId}</h1>
      <p className="mb-6 text-gray-700">
        You will now read a passage. After reading the passage, you will be asked several questions about it.
        You may refer back to the passage while answering. When you're ready, click below to begin.
      </p>

      <div className="mb-6 space-y-4 bg-white p-4 rounded shadow border">
        {data.passage.map((para, index) => (
          <p key={index}>{para}</p>
        ))}
      </div>

      <div className="text-center">
        <button
          onClick={() => navigate(`/lessonMock/${mockId}/reading/${passageId}/q1`)}
          className="bg-blue-600 hover:bg-blue-700 text-black px-6 py-3 rounded-md text-lg shadow"
        >
          Start Questions →
        </button>
      </div>
    </div>
  );
}
